<script setup>
import { reactive, watch, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import { useAssistantSettingsStore } from 'dashboard/store/assistant/settings';

import Input from 'dashboard/components-next/input/Input.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import SettingsHeader from 'dashboard/components-next/assistant/shared/SettingsHeader.vue';

const { t } = useI18n();
const settingsStore = useAssistantSettingsStore();

const state = reactive({
  copilotModel: '',
});

watch(
  () => settingsStore.copilotModel,
  value => {
    state.copilotModel = value || '';
  },
  { immediate: true }
);

const handleSubmit = async () => {
  try {
    await settingsStore.update({
      config: {
        // An empty string resets the copilot to the account model.
        copilot_model: state.copilotModel.trim(),
      },
    });
    useAlert(t('ASSISTANT.COPILOT_SETTINGS.API.SUCCESS_MESSAGE'));
  } catch (error) {
    useAlert(
      error?.response?.data?.error ||
        t('ASSISTANT.COPILOT_SETTINGS.API.ERROR_MESSAGE')
    );
  }
};

onMounted(() => {
  settingsStore.fetch();
});
</script>

<template>
  <div class="flex flex-col w-full max-w-3xl gap-6 p-6 mx-auto">
    <SettingsHeader
      :heading="t('ASSISTANT.COPILOT_SETTINGS.TITLE')"
      :description="t('ASSISTANT.COPILOT_SETTINGS.DESCRIPTION')"
    />
    <form class="flex flex-col gap-4" @submit.prevent="handleSubmit">
      <Input
        v-model="state.copilotModel"
        :label="t('ASSISTANT.COPILOT_SETTINGS.FORM.MODEL.LABEL')"
        :placeholder="t('ASSISTANT.COPILOT_SETTINGS.FORM.MODEL.PLACEHOLDER')"
        :message="t('ASSISTANT.COPILOT_SETTINGS.FORM.MODEL.HELP_TEXT')"
      />
      <div>
        <Button
          type="submit"
          :label="t('ASSISTANT.COPILOT_SETTINGS.FORM.SUBMIT')"
          :is-loading="settingsStore.uiFlags.isUpdating"
          :disabled="settingsStore.uiFlags.isUpdating"
        />
      </div>
    </form>
  </div>
</template>
